
export const HOME_URL = "home";
export const DATA_UPDATE = "data-update";
export const PROFILE = "perfil";
export const BENEFICIARIES = "beneficiaries";
export const VIDEO_ATENCION = "video-atencion";
export const FUND_CHANGE_URL = "fund-change";
export const VOUCHER_PENSION = "voucher-pension";
export const REQUEST_ERROR = "Request-error";
export const TRANSACTIONS = "transactions";
export const ONBOARDING = "onboarding";
export const INICIO = "inicio";

// PASSWORD VALIDATION
export const CONFIRMATION_KEY_URL = "confirmation-key";

export const ROUTING_CAMBIO_VIA_PAGO_PENSION = {
  CAMBIO_VIA_BASE: "pensions",
  CAMBIO_VIA_PAGO_URL: "change-payment-method", //REVISAR
  CAMBIO_VIA_PAGO_HOME: "home",
  CAMBIO_VIA_PAGO: "cambio-via-pago",
  CAMBIO_VIA_PAGO_DATOS_PERSONALES: "datos-personales",
  CAMBIO_VIA_PAGO_DATOS_BANCARIOS: "datos-bancarios",
  CAMBIO_VIA_PAGO_CONFIRMAR: "confirmar",
  CAMBIO_VIA_PAGO_COMPROBANTE: "comprobante",
  CAMBIO_VIA_PAGO_ERROR: "error",
};

export const ROUTING_CONGELAMIENTOS_SALDOS_PENSION = {
  COGELAMIENTO_SALDOS_BASE: "pensions",
  COGELAMIENTO_SALDOS_URL: "congelamiento-saldos", //REVISAR
  COGELAMIENTO_SALDOS_HOME: "home",
};

export const ROUTING_TRAMITE_PENSION = {
  REQUEST: "solicitud",
  BASE_URL: "pensions/tramite-pensiones",
  SEGURIDAD: "seguridad",
  ANTECEDENTES_PENSION: "antecedentes-pension",
  DATOS_PERSONALES: "datos-personales",
  CARGA_DOCUMENTOS: "carga-documentos",
  CONFIRMAR_DATOS: "confirmar-datos",
  VIA_PAGO: "via-pago",
};

export const ROUTING_CONGELAMIENTOS_SALDOS = {
  CONGELAMIENTO_SALDOS_BASE: "pensions",
  CONGELAMIENTO_SALDOS_URL: "congelamiento-saldos",
  CONGELAMIENTO_SALDOS_HOME: "home",
  CONGELAMIENTO_SALDOS: "congelamiento-saldos",
  CONGELAMIENTO_SALDOS_CUENTAS: "congelamiento-cuentas",
  CONGELAMIENTO_SALDOS_CONFIRMAR: "congelamiento-saldos-confirmar",
  CONGELAMIENTO_SALDOS_CUENTAS_OBLIGATORIAS: "congelamiento-cuentas-obligatorias",
  CONGELAMIENTO_SALDOS_CUENTAS_VOLUNTARIAS: "congelamiento-cuentas-voluntarias",
  CONGELAMIENTO_SALDOS_COMPROBANTE: "comprobante",
};

export const ROUTING_CALENDARIO_PAGO_PENSION = {
  CALENDARIO_PAGO_PENSION_BASE: "pensions",
  CALENDARIO_PAGO_PENSION_URL: "calendario-pago-pension",
  CALENDARIO_PAGO_PENSION_HOME: "home",
};

export const URL_CERTIFICADOS = "/certificates/certificados/home";
export const URL_CAMBIO_FONDOS = "/transactions/fund-change";
export const URL_PERFIL_RIESGO = "/tools/advisory/investor-profile";
export const URL_BENEFICIARIOS = "/data-update/beneficiaries/home";
export const URL_ESTIMADOR_PENSION = "/tools/estimator/home/simulate/app/home/onboarding";
export const URL_CAMBIO_AFP_CAPITAL = "https://cambiate.afpcapital.cl/";


export const ROUTING_INFORMACION_PAGO_PENSION = {
  INFORMACION_PAGO_PENSION_BASE: "pensions",
  INFORMACION_PAGO_PENSION_URL: "informacion-pago-pension",
  INFORMACION_PAGO_PENSION_HOME: "home",
};

export const ROUTING_ESTADO_TRAMITE_PENSION = {
  ESTADO_TRAMITE_PENSION_BASE: "pensions",
  ESTADO_TRAMITE_PENSION_URL: "estado-tramite-pension",
  ESTADO_TRAMITE_PENSION_HOME: "estado",
  INICIO: "inicio-estado-tramite",
  CERTIFICADOS_SALDOS: "certificado-saldos",
  CERTIFICADOS_OFERTAS: "certificado-ofertas",
  MODALIDAD_PENSION: "modalidad-pension",
  PAGO_PENSION: "pago-pension",
  TIPO_DESCARGA_CERTIFICADO: "copia"
};

export const ROUTING_REFORMA_PENSIONES = {
  REFORMA_PENSIONES_BASE: "reforma-pensiones",
  BENEFICIOS_REFORMA_PENSIONES: "beneficios-reforma-pensiones",
  BENEFICIOS_REFORMA_HOME: "",
  DETALLE_BENEFICIO_REFORMA: "detalle-beneficio-reforma",
  DETALLE_CONOCE_MAS_REFORMA: "detalle-conoce-mas-reforma",
};

export const ROUTING_INFORME_PENSIONES = {
  INFORME_PENSIONES_BASE: "informe-pensiones",
  HOME_INFORME_PENSIONES: "",
};


export const URL_CONTACTO_TRAMITE_PENSION = "/pensions/contactotdp/contactotdp";

export const ROUTING_TRAMITE_PENSION_INVALIDEZ = {
  REQUEST: "solicitud",
  BASE_URL: "pensions/tramite-pensiones-invalidez",
  SEGURIDAD: "seguridad",
  ANTECEDENTES_PENSION: "antecedentes-pension",
  DATOS_PERSONALES: "datos-personales",
  CARGA_DOCUMENTOS: "carga-documentos",
  CONFIRMAR_DATOS: "confirmar-datos",
  VIA_PAGO: "via-pago",
};